import React, { useState } from "react"
import "./header.css"
import { Link } from "gatsby"

import logo from '../../images/logo/logo.svg'

const NAV = [
    { to: "/", label: "Home" },
    { to: "/vibra-one/", label: "Vibra One" },
    { to: "/guides/", label: "Guides" },
    { to: "/about-us/", label: "About us" },
    { to: "/contact-us/", label: "Contact us" },
]

export const Header = () => {

    const [active, setActive] = useState(false);
    const [isSticky, setSticky] = useState(false);

    const menuToggle = (e) => {
        e.preventDefault();
        setActive(true);
        document.body.classList.add("no-overflow");
    }

    const menuClose = () => {
        setActive(false);
        document.body.classList.remove("no-overflow");
    }

    if (typeof window !== 'undefined' && window.$) {
        const $ = window.$;
        const $body = $('body');
        const windows = $(window);
        const screenSize = windows.width();
        const sticky = $('.header-sticky');

        windows.on('scroll', function () {
            const scroll = windows.scrollTop();
            const headerHeight = sticky.height();
            if (screenSize >= 320) {
                setSticky(scroll >= headerHeight);
            }
        });

        $body.on('click', function (e) {
            const $target = e.target;
            if (!$($target).is('.mobile-menu-overlay__inner') && !$($target).parents().is('.mobile-menu-overlay__inner') && !$($target).is('#mobile-menu-trigger') && !$($target).is('#mobile-menu-trigger i')) {
                setActive(false);
                document.body.classList.remove("no-overflow");
            }
        });
    }

    return (
        <>
            <div className="header-area header-area--default bg-white">
                <header className={`header-area header_absolute header_height-90 header-sticky ${isSticky ? 'is-sticky' : ''}`}>
                    <div className="container-fluid container-fluid--cp-100">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-6">
                                <div className="logo text-left">
                                    <Link to="/" aria-label="VibraHub home"><img src={logo} alt="VibraHub" /></Link>
                                </div>
                            </div>
                            <div className="col-lg-6 d-none d-lg-block">
                                <div className="header__navigation d-none d-lg-block">
                                    <nav className="navigation-menu" aria-label="Main navigation">
                                        <ul className="justify-content-center">
                                            {NAV.map((item) => (
                                                <li key={item.to}>
                                                    <Link to={item.to} activeClassName="active" partiallyActive={item.to !== "/"}>{item.label}</Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                            <div className="col-lg-3 col-6">
                                <div className="header-right-side text-right">
                                    <div className="header-right-items ">
                                        <a
                                            href="#mobile-menu-overlay"
                                            className="mobile-navigation-icon"
                                            id="mobile-menu-trigger"
                                            aria-label="Open menu"
                                            onClick={menuToggle}>
                                            <i className="icon-menu"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>

            <div className={'mobile-menu-overlay ' + (active ? 'active' : '')} id="mobile-menu-overlay">
                <div className="mobile-menu-overlay__inner">
                    <div className="mobile-menu-close-box text-left">
                        <span
                            className="mobile-navigation-close-icon"
                            id="mobile-menu-close-trigger"
                            role="button"
                            tabIndex={0}
                            aria-label="Close menu"
                            onClick={menuClose}
                            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') menuClose() }}>
                            <i className="icon-cross2"></i>
                        </span>
                    </div>

                    <div className="mobile-menu-overlay__body">
                        <nav className="offcanvas-navigation" aria-label="Mobile navigation">
                            <ul>
                                {NAV.map((item) => (
                                    <li key={item.to}><Link to={item.to}>{item.label}</Link></li>
                                ))}
                                <li><Link to="/virtual-demo/">Book a virtual demo</Link></li>
                            </ul>
                        </nav>

                        <div className="mobile-menu-social-share section-space--mt_60">
                            <h6>Follow us</h6>
                            <ul className="social-share">
                                <li>
                                    <a href="https://www.facebook.com/vibrahub" aria-label="Facebook">
                                        <i className="social social_facebook"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/vibrahub/" aria-label="Instagram">
                                        <i className="social social_instagram"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.pinterest.com/vibrahub/" aria-label="Pinterest">
                                        <i className="social social_pinterest"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Header
